// angular
import { NgOptimizedImage } from '@angular/common';
import {
  Component,
  ElementRef,
  inject,
  input,
  OnChanges,
  viewChild,
} from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
// components
import { ButtonComponent } from '@app/core/components/button/button.component';
import { VideoPlayerComponent } from '@app/core/components/video-player/video-player.component';
import { SimpleVideoBoxComponent } from '@app/core/components/simple-video-box/simple-video-box.component';
// directives & pipes
import { HorizontalScrollDirective } from '@app/shared/directives/horizontaly-scroll.directive';
import { ImageSourcePipe } from '@app/shared/pipes/image-source.pipe';
import { TranslateDataPipe } from '@app/shared/pipes/translate-data.pipe';
// interfaces & env
import { ProductLifeStyle } from '@app/+products/shared/interfaces/product.interface';
import { environment } from '@environments/environment';

export type imgData = { src: string; alt: string };

@Component({
  selector: 'pwj-product-usage',
  standalone: true,
  imports: [
    NgOptimizedImage,
    ButtonComponent,
    TranslateModule,
    HorizontalScrollDirective,
    TranslateDataPipe,
    ImageSourcePipe,
    VideoPlayerComponent,
    SimpleVideoBoxComponent,
  ],
  templateUrl: './product-usage.component.html',
  styleUrl: './product-usage.component.scss',
})
export class ProductUsageComponent implements OnChanges {
  public currentDir!: string;
  public baseUrl: string = environment.baseUrl.base;
  public mainLifeStyle!: ProductLifeStyle;

  // inputs
  usageData = input.required<ProductLifeStyle[]>();
  // elements
  lifeStyleSlider = viewChild.required<ElementRef | undefined>('itemsSlider');

  // dependencies
  private readonly _translateService = inject(TranslateService);

  constructor() {
    // set current website direction
    this.currentDir = document.body.dir;

    // set website direction on language change
    this.currentDir = document.body.dir;
    this._translateService.onLangChange.subscribe(lang => {
      this.currentDir = document.body.dir;
    });
  }

  ngOnChanges(): void {
    this.mainLifeStyle = this.usageData()?.[0];
  }

  public selectSliderImg(lifeStyle: ProductLifeStyle) {
    this.mainLifeStyle = lifeStyle;
  }

  // slider scroll buttons functionality
  public scrollToLeft() {
    this.lifeStyleSlider()?.nativeElement.scrollBy({
      left: this.currentDir === 'rtl' ? 200 : -200,
      behavior: 'smooth',
    });
  }

  public scrollToRight() {
    this.lifeStyleSlider()?.nativeElement.scrollBy({
      left: this.currentDir === 'rtl' ? -200 : 200,
      behavior: 'smooth',
    });
  }
}
